import { assign, sendTo, setup, type ActorRefFrom, type EventFromLogic } from 'xstate';
import { serviceBeginMachine } from './serviceBegin.machine';
import { serviceConversationMachine } from './serviceConversation.machine';

export type ServiceResponseActors = {
  conversation: ActorRefFrom<typeof serviceConversationMachine>;
  begin: ActorRefFrom<typeof serviceBeginMachine>;
};

export const serviceResponseSessionMachine = setup({
  types: {
    context: {} as {
      responses: Record<number, ServiceResponseActors>;
      discoveryBegins: Record<number, ServiceResponseActors['begin']>;
    },
    events: {} as
      | { type: 'OPEN_RESPONSE'; responseId: number }
      | Extract<EventFromLogic<typeof serviceBeginMachine>, { type: 'BEGIN_DISCOVERY' }>,
  },
  actors: { conversation: serviceConversationMachine, begin: serviceBeginMachine },
}).createMachine({
  id: 'serviceResponseSession',
  context: { responses: {}, discoveryBegins: {} },
  on: {
    BEGIN_DISCOVERY: {
      guard: ({ event }) =>
        Number.isSafeInteger(event.listing.providerServiceListingId) &&
        event.listing.providerServiceListingId > 0,
      actions: [
        assign({
          discoveryBegins: ({ context, event, spawn }) => {
            const listingId = event.listing.providerServiceListingId;
            if (context.discoveryBegins[listingId]) return context.discoveryBegins;
            return {
              ...context.discoveryBegins,
              [listingId]: spawn('begin', { input: { listingId } }),
            };
          },
        }),
        sendTo(
          ({ context, event }) => context.discoveryBegins[event.listing.providerServiceListingId],
          ({ event }) => event
        ),
      ],
    },
    OPEN_RESPONSE: {
      guard: ({ context, event }) =>
        Number.isSafeInteger(event.responseId) &&
        event.responseId > 0 &&
        !context.responses[event.responseId],
      actions: assign({
        responses: ({ context, event, spawn }) => ({
          ...context.responses,
          [event.responseId]: {
            conversation: spawn('conversation', { input: { responseId: event.responseId } }),
            begin: spawn('begin', { input: { responseId: event.responseId } }),
          },
        }),
      }),
    },
  },
});
